module.exports = __webpack_public_path__ + "img/UA.4703f756.jpg";